import type { ComponentChildren } from "preact";
import { Link } from "wouter-preact";
import { useSiteConfig } from "../features/tenant/SiteConfigContext";
import { routes } from "../lib/route";
import "./PortalLayout.css";

export function PortalLayout({
  headerActions,
  children,
}: {
  headerActions?: ComponentChildren;
  children: ComponentChildren;
}) {
  const site = useSiteConfig();

  return (
    <div class="portal-layout">
      <header class="portal-header">
        <Link
          href={`~${routes.portal.overview()}`}
          className="portal-tenant"
          aria-label={`${site.displayName} portal`}
        >
          {site.logoUrl ? (
            <img src={site.logoUrl} alt={site.displayName} />
          ) : (
            <strong>{site.displayName}</strong>
          )}
        </Link>
        {headerActions}
      </header>
      <main class="portal-content">{children}</main>
    </div>
  );
}
